export default {
    subscriptions() {
        return axios.get('/api/hpc/subscriptions');
    },
    sendSubAction(data) {
        return axios.post('/api/hpc/subscriptions/sendaction', data);
    },
    updateCard(data) {
        return axios.post("/api/hpc/subscriptions/" + data.sub_id + "/updatecard", data);
    },
};
